function DateTimeSelector({
    locked,
    type,
    startDate,
    setStartDate,
    startTime,
    setStartTime,
}) {
    
    const todayDate = new Date();

    let day = todayDate.getDate();
    let month = todayDate.getMonth() + 1;
    let year = todayDate.getFullYear();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;

    const defaultTodayDate = year + "-" + month + "-" + day;

    let minutes = todayDate.getMinutes();
    if (minutes < 10) minutes = "0" + minutes;

    const defaultNowTime = todayDate.getHours() + ":" + minutes;

    return (
        <div className="DateTimeSelector">
            <div className="picker">
                {
                    type === 'date'
                        ? <div className="input-wrapper">
                            <input
                                className="dateInput"
                                type={type}
                                value={startDate || defaultTodayDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                disabled={locked}
                            />
                            <span className="custom-icon">
                                <svg class="icon-calendar" xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                </svg>
                            </span>
                        </div>
                        : <div className="input-wrapper">
                            <input
                                className="timeInput"
                                type={type}
                                value={startTime || defaultNowTime}
                                onChange={(e) => setStartTime(e.target.value)}
                                disabled={locked}
                            />
                            <span className="custom-icon">
                                <svg class="icon-clock" xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                            </span>
                        </div>
                }
            </div>
        </div>
    )
}

export default DateTimeSelector;
